module.exports = __webpack_public_path__ + "img/35.70aa9bce.png";